import { useQuery } from 'react-query';
import { loadExpTemplateList } from '../api/expDetailsTemplateApi';
import useExpDetailsRouteParams from '../useExpDetailsRouteParams';
import { expDetailsTemplateKeys } from '../api/exp-details-template-key-factory';

const useExpTemplateList = () => {
  const { experimentKey, projectId } = useExpDetailsRouteParams();

  const enabled = Boolean(experimentKey && projectId);

  return useQuery(
    expDetailsTemplateKeys.templateList(projectId),
    () => {
      return loadExpTemplateList({
        experimentKey,
        projectId
      });
    },
    {
      enabled
    }
  );
};

export default useExpTemplateList;
